import { render } from "./Stack.vue?vue&type=template&id=0bda212c"
import script from "./Stack.vue?vue&type=script&lang=js"
export * from "./Stack.vue?vue&type=script&lang=js"
script.render = render

export default script